import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { ApiService } from '../../../_shared/services/api.service';
import { map, catchError, switchMap, first } from 'rxjs/operators';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { CardService } from '../card.service';
import { UserService } from '../user.service';
import { AccountResponse } from 'src/app/_shared/models/account-models/account-response';
import { Card } from '../../../_shared/models/card-models/card';
import { CardType } from '../../../_shared/models/card-models/CardType';

@Injectable({
  providedIn: 'root'
})
export class ReturnGuard  {
  constructor(
    private apiService: ApiService,
    private router: Router,
    private userService: UserService,
    private cardService: CardService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const trackId = route.paramMap.get('trackId');

    return this.apiService
      .getVerifyUserSessionByAccountId(trackId)
      .pipe(
        switchMap((trackId: string) => {
          return this.apiService.getCustomer(trackId);
        }),
        switchMap((user: AccountResponse) => {
          this.userService.setUser(user);
          this.cardService.setCurrentCard(trackId);

          return this.cardService.getCurrentCard().pipe(
            map((card: Card) => {
              return { user, card };
            })
          );
        }),
        map(({ user, card }) => {
          const cardType = this.mapCardPathToCardType(card?.path);
          if (cardType === 12) {
            // Redirect to New GM Card site - dashboard
            return this.router.createUrlTree(['/dashboard']);
          } else {
            // Redirect to old GM Card site - summary
            return this.router.createUrlTree(['*']);
          }
        }),
        catchError((err: any) => {
          this.apiService
            .getSsoUrl(null, true)
            .pipe(first())
            .subscribe(redirectUrl => {
              window.location.href = redirectUrl;
            });
          return of(false);
        })
      );
  }
  private mapCardPathToCardType(cardPath: string): CardType {
    return cardPath.toString() === '12' ? 12 : 13;
  }
}
